module.exports = __webpack_public_path__ + "./images/fac001a3adf854f6f8264b1ef287c40b.webp";